/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { setLoading } from 'src/app/redux/actions/user.actions';
import { AppState } from 'src/app/redux/app.state';
import { CarModel, CarModelType, Engine } from 'src/typings';
import { CarModelTypeService } from '../car-model-type.service';

@Component({
  selector: 'app-car-model-type-create',
  templateUrl: './car-model-type-create.component.html',
  styleUrls: ['./car-model-type-create.component.scss']
})
export class CarModelTypeCreateComponent {
  @Input() set carModel(carModel: CarModel) {
    this.createForm.controls.carModel.setValue(carModel);
    return;
  }

  @Input() dialogRef: MatDialogRef<CarModelTypeCreateComponent> | undefined;

  @Output() newCarModifictionEvent: EventEmitter<CarModelType> = new EventEmitter();

  createForm = this.fb.group({
    description: new UntypedFormControl(),
    date_from: new UntypedFormControl(),
    date_to: new UntypedFormControl(),
    engines: new UntypedFormControl([]),
    carModel: new UntypedFormControl()
  });

  constructor(
    private fb: UntypedFormBuilder,
    private carModelTypeService: CarModelTypeService,
    private store: Store<AppState>
  ) {}

  get enginesControl(): UntypedFormControl {
    return this.createForm.controls.engines as UntypedFormControl;
  }

  create() {
    const { description, date_from, date_to, engines, carModel } = this.createForm.value;
    this.store.dispatch(setLoading({ payload: true }));
    this.carModelTypeService
      .create({
        description,
        manufacture_date_from: date_from,
        manufacture_date_to: date_to,
        engineIds: engines.map((engine: Engine) => engine.id),
        carModelId: carModel.id
      })
      .subscribe((newCar) => {
        this.newCarModifictionEvent.emit(newCar);
        this.store.dispatch(setLoading({ payload: false }));
        if (this.dialogRef) this.dialogRef.close();
      });
  }
}
